import React from 'react';
import styles from './styles.module.css';

import NumberToPrice from '@/_components/NumberToPrice';
import { Box, Center, Flex, Spinner, Text } from '@chakra-ui/react';
import ZoneAlert from './ZoneAlert';
import { useTranslations } from 'next-intl';
import { IDeliveryZone } from '@/_types';

function Marker({
  zoneData,
  hover,
  isLoading,
  errorZone = false,
  isLocation = false,
}: {
  zoneData?: IDeliveryZone | { id: string; min_order_amount: number; free_delivery_order_amount?: number } | null;
  hover: boolean;
  isLoading: boolean;
  errorZone?: boolean;
  isLocation?: boolean;
}) {
  const t = useTranslations();
  return (
    <>
      <Box
        className={`${styles.marker} ${hover ? styles.hover : ''}`}
        transform={`translate(-50%, calc(-60% - 10px))`}
      >
        <Center className={styles.head} bgColor={'#EC5962'}>
          <Spinner color='white' opacity={isLoading ? 1 : 0} />
        </Center>
        <div className={styles.stick} />
        <div className={styles.shadow} />
      </Box>
      {isLocation ? (
        <Box
          zIndex={10}
          position='absolute'
          top={{ base: 20, lg: 3 }}
          left='50%'
          transform='translateX(-50%)'
          data-state={Boolean(isLocation) ? 'open' : 'closed'}
          _open={{
            animationName: 'fade-in, scale-in',
            animationDuration: '300ms',
          }}
          _closed={{
            animationName: 'fade-out, scale-out',
            animationDuration: '120ms',
          }}
        >
          <ZoneAlert title={t('geolocation_access_required')} />
        </Box>
      ) : errorZone ? (
        <Box
          zIndex={10}
          position='absolute'
          top={{ base: 20, lg: 3 }}
          left='50%'
          transform='translateX(-50%)'
          data-state={Boolean(errorZone) ? 'open' : 'closed'}
          _open={{
            animationName: 'fade-in, scale-in',
            animationDuration: '300ms',
          }}
          _closed={{
            animationName: 'fade-out, scale-out',
            animationDuration: '120ms',
          }}
        >
          <ZoneAlert />
        </Box>
      ) : (
        <>
          {(zoneData?.min_order_amount ||
            (zoneData)?.free_delivery_order_amount ||
            0) > 0 && (
              <Box
                p={4}
                top={3}
                left='50%'
                rounded='xl'
                zIndex={10}
                bg='#333333'
                color='white'
                w={'fit-content'}
                position='absolute'
                whiteSpace='nowrap'
                transform='translateX(-50%)'
                data-state={Boolean(zoneData) ? 'open' : 'closed'}
                _open={{
                  animationName: 'fade-in, scale-in',
                  animationDuration: '300ms',
                }}
                _closed={{
                  animationName: 'fade-out, scale-out',
                  animationDuration: '120ms',
                }}
              >
                <Box key={zoneData?.id} fontSize={'12px'} fontWeight={400}>
                  {(zoneData?.min_order_amount || 0) > 0 && (
                    <Flex gap={2}>
                      <Text>Минимальная сумма заказа:</Text>
                      <NumberToPrice
                        value={zoneData?.min_order_amount || 0}
                        unstyled={true}
                      />
                    </Flex>
                  )}
                  {((zoneData)?.free_delivery_order_amount || 0) > 0 && (
                    <Flex gap={2}>
                      <Text>Бесплатная доставка от</Text>
                      <NumberToPrice
                        value={(zoneData)?.free_delivery_order_amount || 0}
                        unstyled={true}
                      />
                    </Flex>
                  )}
                </Box>
              </Box>
            )}
        </>
      )}
    </>
  );
}

export default Marker;
